//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import IconComponent from 'app_components/commons/icons'
import { CgMediaLive } from 'react-icons/cg'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../newsCardCommon.scss'

// @ADD Component types
interface INewsCardCommonLayoutProps {
  cover: string,
  postDate: string,
  title: string
  subtitle: string
  version: 'simple' | 'large'
  list?: boolean
  live?: boolean
  onClick?: () => void
}

const NewsCardCommonLayout: React.FC<INewsCardCommonLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <>
      {props.version === 'large' && (
        <div onClick={props.onClick} className={`news_card_large-component ${props.list ? 'list' : ''}`}>
          <div className="news-card-image">
            <img src={props.cover} alt={`Imagen de la noticia ${props.title}`} />
          </div>
          <div>
            {!props.live ?
              <div className="news-card-post-date">
                <IconComponent svg='Clock' width={24} color={'#0085CA'} />
                <span >
                  {props.postDate}
                </span>
              </div>
              :
              <div className='live-text-card' >
                <CgMediaLive/>
                <span>En vivo</span>
              </div>
            }
            <div className="news-card-title">{props.title}</div>
            <div className="news-card-subtitle">{props.subtitle}</div>
          </div>
        </div>
      )}
      {props.version === 'simple' && (
        <div onClick={props.onClick} className='news_card_simple-component'>
          <div className="news-card-image" style={{backgroundImage: `url(${props.cover})`}}>
            <div className="news-card-title">{props.title}</div>
          </div>
        </div>
      )}
    </>
  )
}

export default NewsCardCommonLayout
